import React, { useState, useEffect } from 'react';
import WorkSampleDisplay from '@punchcard/core/components/WorkSample/WorkSampleDisplay';
import { useFormContext } from 'react-hook-form';
import { parseNumberSeries } from '@punchcard/core/utils/utils';

interface IProps {
	isPrinting?: boolean;
	setAllDocumentsLoaded?: (setAllDocumentsLoaded: boolean) => void;
	selectedPages?: number[];
	setSelectedPages?: React.Dispatch<React.SetStateAction<number[]>>;
	isWorkSampleReview?: boolean;
	isPdfGeneratingView?: boolean;
	isPreparing?: boolean;
}

function WorkSample(props: IProps) {
	const methods = useFormContext<StudentWorkSampleDTO>();
	const sample = methods.getValues();
	const [loadedDocs, setLoadedDocs] = useState<Record<string, boolean>>({});

	const validDocuments = (() => {
		let docs = sample.documents.filter(doc =>
			doc.documentFileUrl !== undefined &&
			doc.pageNumbers !== undefined &&
			doc.pageNumbers !== ''
		);
		if (props.selectedPages?.length && props.isPdfGeneratingView) {
			docs = docs.filter(doc => {
				const docPages = parseNumberSeries(doc.pageNumbers);
				return docPages.some(pageNum => props.selectedPages?.includes(pageNum));
			});
		}
		return docs;
	})();

	const handleDocumentReady = (documentId: string) => {
		setLoadedDocs(prev => ({
			...prev,
			[documentId]: true
		}));
	};

	useEffect(() => {
		if (!props.setAllDocumentsLoaded) { return; }

		if (validDocuments.length > 0) {
			const allDocsLoaded = validDocuments.every(
				doc => loadedDocs[`document${doc.courseActivityId}`] === true
			);

			if (allDocsLoaded) {
				props.setAllDocumentsLoaded(true);
			}
		}
		else {
			props.setAllDocumentsLoaded(true);
		}
	}, [loadedDocs, validDocuments, props, sample.documents.length]);

	return (
		<React.Fragment>
			{sample && validDocuments.map((document) => (
				<WorkSampleDisplay
					documentUrl={document.documentFileUrl}
					jsonUrl={document.jsonFileUrl}
					pageNumbers={document.pageNumbers}
					isPrinting={props.isPrinting}
					key={`document${document.courseActivityId}`}
					setDocumentReady={() => handleDocumentReady(`document${document.courseActivityId}`)}
					selectedPages={props.selectedPages}
					setSelectedPages={props.setSelectedPages}
					isFinalGrade={document.gradeValue !== undefined}
					isWorkSampleReview={props.isWorkSampleReview}
					isPdfGeneratingView={props.isPdfGeneratingView}
					isPreparing={props.isPreparing}
				/>
			))}
		</React.Fragment>
	);
}

export default WorkSample;